import React from 'react'

import './DownloadApp.scss'

import { Img } from '@components/shared/elements'

class DownloadApp extends React.Component {

  render() {

    // Other container's classes available are:
    // download-app--inline
    // download-app--inline-medium
    // download-app--inline-large
    // align-center (it's from foundation)

    let containerClass = 'download-app mb2'

    let customContainerClass = this.props.className

    if (customContainerClass) {
      containerClass = `${containerClass} ${customContainerClass}`
    }

    return (

      <div className={containerClass}>

        {this.props.title.show &&
          <h6 className='text'>{this.props.title.label}</h6>
        }

        <ul className='menu align-center'>

          {this.props.data.map((item, index) => (

            <li key={`download-app-item-${index}`}>
              <a href={item.url} title={item.label} target='_blank' rel='noopener noreferrer'>
                <Img src={item.image} alt={item.label} width='135' />
              </a>
            </li>

          ))}

        </ul>
      </div>

    )
  }
}

DownloadApp.defaultProps = {
  data: [],
  title: {
    label: 'Baixe o aplicativo',
    show: true,
  },
}

export default DownloadApp



// WEBPACK FOOTER //
// ./src/components/shared/elements/DownloadApp/DownloadApp.js